export const mepRef40EventType = ['online', 'in-person'] as const;
export const mepRef40EventTypeLabels: Record<(typeof mepRef40EventType)[number], string> = {
  online: 'Online',
  'in-person': 'In Person',
};
